export const getFundsCategories = (state, fundsCategories) => {
  state.fundsCategories = fundsCategories
}

export const setLoading = (state, value) => {
  state.loading = value;
} 